import api from "../../../api/axios";

const BASE_URL = "/api/v1/power/organizations";

const getOrganizations = async (params = {}) => {
  const response = await api.get(BASE_URL, { params });
  return response.data;
};

const getOrganizationById = async (id) => {
  const response = await api.get(`${BASE_URL}/${id}`);
  return response.data;
};

const createOrganization = async (data) => {
  const response = await api.post(BASE_URL, data);
  return response.data;
};

const updateOrganization = async ({ id, data }) => {
  const response = await api.patch(`${BASE_URL}/${id}`, data);
  return response.data;
};

const deleteOrganization = async (id) => {
  const response = await api.delete(`${BASE_URL}/${id}`);
  return response.data;
};

const fetchOrganizationCoaches = async (id, params = {}) => {
  const response = await api.get(`${BASE_URL}/${id}/coaches`, { params });
  return response.data;
};

const getMyOrganizationCoaches = async () => {
  const response = await api.get(`${BASE_URL}/me/coaches`);
  return response.data;
};

const organizationService = {
  getOrganizations,
  getOrganizationById,
  createOrganization,
  updateOrganization,
  deleteOrganization,
  fetchOrganizationCoaches,
  getMyOrganizationCoaches,
};

export default organizationService;
